import React, { useEffect, useState } from 'react';
import { getQueryString } from '../../../utils/params';
import useFullPageLoader from '../../commons/isn/useFullPageLoader';
import { BannerOurOffice, BreadcrumbServicedOffice, MenuServicedOffice } from '../common';
import { getOfficeInfo, getOverviewInfo, getIntroduceOffice, getContactsOffice } from '../servicedOffice.api';
import { useTranslation } from 'react-i18next';
import { ServicedOfficeContactUs } from '../pages';
import { useParams } from 'react-router-dom';

function ServicedOfficeOverviewComponent() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const { language } = useParams();
  const { t } = useTranslation();
  const [overviewInfo, setOverviewInfo] = useState();
  const [videoUrl, setVideoUrl] = useState('');
  const [officeId, setOfficeId] = useState(0);
  const [introduce, setIntroduce] = useState([]);
  const [contact, setContacts] = useState([]);
  const [showContact, setShowContact] = useState(false);
  const [imageUrl, setImageUrl] = useState('')

  useEffect(() => {
    showLoader();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    Promise.all([
      getOfficeInfo(getQueryString({ language })),
      getIntroduceOffice(getQueryString({ language })),
      getContactsOffice(getQueryString({ language })),
    ]).then(values => {
      if (values) {
        setOfficeId(values[0][0]?.id ?? 0);
        setIntroduce(values[1] ?? []);
        setContacts(values[2] ?? []);
      }
      hideLoader();
      //eslint-disable-next-line
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (officeId !== 0) {
      getOverviewInfo(getQueryString({ language, officeId })).then(res => {
        if (res) {
          setOverviewInfo(res);
          const _url = res?.videoUrl?.replace('watch?v=', 'embed/');
          setVideoUrl(_url);
          setImageUrl(res?.imageUrl)
        }
      });
      //eslint-disable-next-line
    }
    //eslint-disable-next-line
  }, [officeId]);

  function createMarkup(data) {
    if (data) {
      return { __html: data };
    }
  }

  const handleButtonBook = () => {
    setShowContact(true);
  };

  const handleWithUs = () => {
    return (
      <>
        <div className="start-with-us">
          <div className="content-img d-block d-md-flex">
            <div className="col-md-6 col-12 d-flex">
              <div className="why_title">
                <span className="title">{overviewInfo.title}</span>
                <span className="title-content">{overviewInfo.content}</span>
              </div>
            </div>
            <div className="col-md-6 col-12 d-flex align-items-center">
              <div className="content">
                {contact && contact.length > 0
                  ? contact.map((el, index) => (
                    <div key={el.id} className="d-flex">
                      <div className="content__index">{index + 1}</div>
                      <div>
                        <div className="content__title">{el.title}</div>
                        <div dangerouslySetInnerHTML={createMarkup(el.content)}></div>
                      </div>
                    </div>
                  ))
                  : ''}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const handleOverview = () => {
    return (
      <>
        {introduce && introduce.length > 0
          ? introduce.map((item, index) => {
            return (
              <div key={index} className={` ${index % 2 === 0 ? 'welcome' : 'reasons'} `}>
                <div className="image">
                  <img src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`} alt="" />
                </div>
                <div className="content-img">
                  <div className="content-img__title">{item.name}</div>
                  <div dangerouslySetInnerHTML={createMarkup(item.content)}></div>
                </div>
              </div>
            );
          })
          : ''}
        {handleWithUs()}
        <div className="container">
          <div className="d-flex justify-content-center mt-5 mb-5">
            <input
              className="btn-booknow"
              type="button"
              onClick={handleButtonBook}
              value={t('detailApartment.contact_us_title')}
            />
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <BreadcrumbServicedOffice />
      <BannerOurOffice />
      <MenuServicedOffice />
      <ServicedOfficeContactUs
        showLogin={showContact}
        closeLogin={() => {
          setShowContact(false);
        }}
      />
      <div id="servicedOfficeOverview">
        {overviewInfo ? (
          <><div className="container">
            <div className="row px-3 overview-desc">{handleOverview()}</div>
          </div>
            <div className="container">
              {overviewInfo.isShow === false || overviewInfo.isShow === 0?
                <iframe
                  className="service-video"
                  src={videoUrl}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Embedded youtube" /> :
                <div className="image-show-overview">
                  <img src={`${process.env.REACT_APP_ISN_IMAGE_URL}${imageUrl}`} alt="" />
                </div>}
            </div></>

        ) : (
          ''
        )}
      </div>
      {loader}
    </>
  );
}

export default ServicedOfficeOverviewComponent;
